import React from 'react';
import Footer from '../Footer';
import './Cancellation.css';
import aboutIcon from "../../assets/abouticon.png";

const CancellationPolicy = () => {
  return (
    <>
      {/* Section 1 */}
      <section className="cancellation-section1">
        <div className="section1-container">
          <img src={aboutIcon} alt="About Icon" className="about-icon" />
          <h1 className="section1-heading">CANCELLATION AND REFUND POLICY</h1>
          <p className="section1-paragraph">
            At Polymath-Kids, we are passionate about customer service. We understand that plans can change, so please review the following information before registering so you're aware of your commitment to Polymath-Kids.com
          </p>
        </div>
      </section>

      {/* Section 2 */}
      <section className="cancellation-section2">
        <div className="section2-container">
          <p className="section2-paragraph">
            We use class registrations to predict whether or not a session will start, so last-minute student cancellations can affect other students enrolled in the class as well as our instructors who are planning to teach. We've created the following policies to be fair to all parties involved:<br /><br />
            Online learning classes and camps with paid registration will receive 100% cancellation with at least 7 days' notice prior to the start of class. A 50% refund is applicable with less than 7 days' notice, however no refunds will be provided with less than 72 hours notice prior to the start of the class.<br /><br />
            Our commitment to education and access to computer learning for all, we are always willing to work with parents and students to relocate a class that may not be a good fit - always ask by contacting us and we can work out a time that suits the child.<br /><br />
            We will use reasonable efforts to give notice of any cancellation of any courses for unforeseen reasons. If the course cannot be rescheduled, you may be entitled to a refund of any fee paid in respect of the cancelled services but shall not otherwise be entitled to any compensation, costs, losses or damages arising from such cancellation.<br /><br />
            Polymath-Kids offer NO refunds or make-up sessions for missed group classes. However our instructors may try to help the child with the missed work in the next class, if possible and feasible for the instructor.<br /><br />
            These policies constitute the entire agreement between all parties and supersede any previous communications, representations or agreements between parties, whether oral or written, regarding transactions hereunder. Your purchase will constitute your acceptance of these terms which may not be changed except by an amendment signed by an authorized representative of each party.<br /><br />
            Please contact us if you have any questions through email info@polymath-kids.com or WhatsApp or Call +4747650619.
          </p>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default CancellationPolicy;
